import { makeAutoObservable } from 'mobx';
import _ from 'lodash';
import moment from 'moment';

class FeedItemsState {
  feedItems;
  nextLink;
  loadMore;
  feedState;

  constructor() {
    makeAutoObservable(this);
  }

  receiveProps({feedItems, nextLink, loadMore, feedState}) {
    this.feedItems = feedItems;
    this.nextLink = nextLink;
    this.loadMore = loadMore;
    this.feedState = feedState;
  }

  async load() {
    await this.loadMore();
  }

  get sortedFeedItems() {
    return _.orderBy(this.feedItems, 'publishedAt', 'desc');
  }

  get nextWeeksFeedItems() {
    return _.filter(this.sortedFeedItems, feedItem => {
      return feedItem.publishedAt > moment().toDate();
    });
  }

  get currentFeedItems() {
    return _.filter(this.sortedFeedItems, feedItem => {
      return moment(feedItem.publishedAt).isSameOrBefore(moment(), 'day') && moment(feedItem.publishedAt).isSameOrAfter(moment().subtract(7, 'days'), 'day');
    });
  }

  get olderFeedItems() {
    return _.filter(this.sortedFeedItems, feedItem => {
      return moment(feedItem.publishedAt).isSameOrBefore(moment().subtract(8, 'days'), 'day');
    });
  }
}

export default FeedItemsState;
